window.addEventListener('DOMContentLoaded', () => {
    this.scrollSection();
    this.handleScroll();
    // Add scroll event listener to the window
    
    window.addEventListener('scroll', scrollSection);
});
document.getElementById("searchInput").addEventListener("keydown", function(event) {
    if (event.key === "Enter") {
        event.preventDefault();
    }
});

// Select all elements with the class "varient-close-popup"
const closeButtons = document.querySelectorAll('.varient-close-popup');

closeButtons.forEach(button => {
    button.addEventListener('click', function(event) {
        event.preventDefault();
        var productMeta = event.target.closest('.product-item__inner');
        var variantPopup = productMeta.querySelector('.variant-popup');
        var addToBoxBtn = document.querySelectorAll('.deals-page .add-to-box .btn');
   
        if (variantPopup) {
            variantPopup.classList.add('hidden');
            variantPopup.classList.remove('show');
            productMeta.classList.remove('show');
            addToBoxBtn.forEach(addbtn => {
                addbtn.classList.remove('disabled');
            });
        }
    });
});

var checkboxes = document.querySelectorAll('#checkboxes');
var addToCartBtn = document.querySelector(".product-form__cart-submit");
    addToCartBtn.setAttribute("disabled", "disabled");
// Attach click event listener to each div element
checkboxes.forEach(function(checkbox) {
    checkbox.addEventListener('click', function() {
        // Get the value of the data-button-id attribute
        var buttonId = this.getAttribute('data-button-id');
        var limitId = this.getAttribute('data-product-limit');
        var limitIdFirst = this.getAttribute('data-product-limit-First');
        var limitIdSecond = this.getAttribute('data-product-limit-Second');
        var limitIdThird = this.getAttribute('data-product-limit-Third');
        var offerPriceFirst = this.getAttribute('data-product-offer-First');
        var offerPriceSecond = this.getAttribute('data-product-offer-Second');
        var offerPriceThird = this.getAttribute('data-product-offer-Third');
        var sectionId = this.getAttribute('data-sec-id');
        var productName = this.getAttribute('data-product-name');
        // For hide and show add to cart button
        var addedToCartElements = document.querySelectorAll(".added_to_cart");
        var headingOffer = document.querySelector('.heading-offer');
        // Check if the element exists
        if (headingOffer) {
            var headingOfferStyle = window.getComputedStyle(headingOffer);
        }
        var anyNotDisplayedBlock = false;
     var finalAdBtn = document.querySelector('#cart_tab_3_added');
        // Iterate over each element
        addedToCartElements.forEach(function(element) {
            if (getComputedStyle(element).display !== 'block') {
                anyNotDisplayedBlock = true;
            } else {
                setTimeout(() => {
                if (headingOfferStyle.display === 'block') {
                    anyNotDisplayedBlock = false;
                } else {
                    anyNotDisplayedBlock = true;
                }
                if (getComputedStyle(finalAdBtn).display === 'block') {
                    anyNotDisplayedBlock = false;
                }
                if (!anyNotDisplayedBlock) {
                    addToCartBtn.removeAttribute("disabled"); 
                    addToCartBtn.classList.remove("btn--secondary"); 
                    addToCartBtn.classList.add("btn--primary"); 
                } else {
                    addToCartBtn.setAttribute("disabled", "disabled"); 
                    addToCartBtn.classList.add("btn--secondary"); 
                    addToCartBtn.classList.remove("btn--primary"); 
                }
                
            }, 1000);
            }
        });
        if (!anyNotDisplayedBlock) {
            addToCartBtn.removeAttribute("disabled"); 
            addToCartBtn.classList.remove("btn--secondary"); 
            addToCartBtn.classList.add("btn--primary"); 
        } else {
            addToCartBtn.setAttribute("disabled", "disabled"); 
            addToCartBtn.classList.add("btn--secondary"); 
            addToCartBtn.classList.remove("btn--primary"); 
        }
        
        var checkboxMain = document.getElementById(buttonId);

        // Attach click event listener
        checkboxMain.addEventListener('click', function(event) {
            // Check if the checkbox is checked
            var productMeta = event.target.closest('.product-item__inner');
            var variantPopup = productMeta.querySelector('.variant-popup');
            var addToBoxBtn = document.querySelectorAll('.deals-page .add-to-box .btn');
            
            var hasVariants = productMeta.querySelector('.Size_var_wrap').children.length > 0;
            if (hasVariants) {
                // For hide and show add to cart button
        var addedToCartElements = document.querySelectorAll(".added_to_cart");
       
        var anyNotDisplayedBlock = false;

        // Iterate over each element
        addedToCartElements.forEach(function(element) {
            if (getComputedStyle(element).display !== 'block') {
                anyNotDisplayedBlock = true;
            }
        });
        
                if (!anyNotDisplayedBlock) {
                    addToCartBtn.removeAttribute("disabled"); 
                    addToCartBtn.classList.remove("btn--secondary"); 
                    addToCartBtn.classList.add("btn--primary"); 
                } else {
                    addToCartBtn.setAttribute("disabled", "disabled"); 
                    addToCartBtn.classList.add("btn--secondary"); 
                    addToCartBtn.classList.remove("btn--primary"); 
                } 
                var label = event.target.nextElementSibling;
                var button = checkboxMain.parentElement;
                button.classList.remove('btn--secondary');
                button.classList.add('btn--primary');
            if (!event.target.checked) {     
                console.log('selectItem1');
                selectItem(event, limitId, limitIdFirst, limitIdSecond, limitIdThird, offerPriceSecond, offerPriceFirst, offerPriceThird, sectionId, productName, checkboxMain);
            } else {
                    variantPopup.classList.add('show');
                    productMeta.classList.add('show');
                    addToBoxBtn.forEach(addbtn => {
                        addbtn.classList.add('disabled');
                    });
                    variantPopup.classList.remove('hidden');
                    // Get all radio buttons
                    var radioButtons = document.querySelectorAll('input[type="radio"][data-variant-input]');
                    
                    // Attach change event listener to each radio button
                    radioButtons.forEach(function(radioButton) {
                        radioButton.addEventListener("change", function(events) {
                            // Get the selected radio button's data-variant-id
                            var selectedVariantId = events.target.getAttribute("data-variant-id");
                            var selectedbuttonId = events.target.getAttribute("data-button-id");
                            console.log('selectedbuttonId s');
                            console.log(selectedbuttonId);
                            // Get the corresponding checkbox
                            var checkbox = document.querySelector('#'+selectedbuttonId+'[type="checkbox"]');
                            console.log('selectItem2');
                            // Update the checkbox's data-variant-id attribute
                            checkbox.setAttribute("data-id-variant", selectedVariantId);
                            selectItem(event, limitId, limitIdFirst, limitIdSecond, limitIdThird, offerPriceSecond, offerPriceFirst, offerPriceThird, sectionId, productName, checkboxMain);
                            variantPopup.classList.add('hidden');
                            variantPopup.classList.remove('show');
                            productMeta.classList.remove('show');
                            addToBoxBtn.forEach(addbtn => {
                                addbtn.classList.remove('disabled');
                            });
                        
                        });
                    });
                    radioButtons.forEach(function(radioButton) {
                        radioButton.addEventListener("click", function(events) {
                            // Get the selected radio button's data-variant-id
                            var selectedVariantId = events.target.getAttribute("data-variant-id");
                            var selectedVariantPrice = events.target.getAttribute("data-variant-price");
                            var selectedbuttonId = events.target.getAttribute("data-button-id");
                            console.log('selectedbuttonId s');
                            console.log(selectedbuttonId);
                            // Get the corresponding checkbox
                            var checkbox = document.querySelector('#'+selectedbuttonId+'[type="checkbox"]');

                            // Update the checkbox's data-variant-id attribute
                            checkbox.setAttribute("data-id-variant", selectedVariantId);
                            const variantPrice = parseInt(selectedVariantPrice);
                            checkbox.setAttribute("data-price-variant", variantPrice);
                            console.log('selectItem3');
                            selectItem(event, limitId, limitIdFirst, limitIdSecond, limitIdThird, offerPriceSecond, offerPriceFirst, offerPriceThird, sectionId, productName, checkboxMain);
                            variantPopup.classList.add('hidden');
                            variantPopup.classList.remove('show');
                            productMeta.classList.remove('show');
                            addToBoxBtn.forEach(addbtn => {
                                addbtn.classList.remove('disabled');
                            });
                        
                        });
                    });
                }

            } else {
                console.log('selectItem4');
                selectItem(event, limitId, limitIdFirst, limitIdSecond, limitIdThird, offerPriceSecond, offerPriceFirst, offerPriceThird, sectionId, productName, checkboxMain);
            }
           
            
        });
    });
});

function  selectItem(event, limitId, limitIdFirst, limitIdSecond, limitIdThird, offerPriceSecond, offerPriceFirst, offerPriceThird, sectionId, productName, checkboxMain) {
   
    var addToCartBtn = document.querySelector(".product-form__cart-submit");

   // For hide and show add to cart button
     var addedToCartElements = document.querySelectorAll(".added_to_cart");
        
     var anyNotDisplayedBlock = false;

     // Iterate over each element
     addedToCartElements.forEach(function(element) {
         if (getComputedStyle(element).display !== 'block') {
             anyNotDisplayedBlock = false;
         }
     });
     
     if (!anyNotDisplayedBlock) {
         addToCartBtn.removeAttribute("disabled"); 
         addToCartBtn.classList.remove("btn--secondary"); 
         addToCartBtn.classList.add("btn--primary"); 
     } else {
         addToCartBtn.setAttribute("disabled", "disabled"); 
         addToCartBtn.classList.add("btn--secondary"); 
         addToCartBtn.classList.remove("btn--primary"); 
     }
     

        var label = event.target.nextElementSibling;
        var button = checkboxMain.parentElement;
         button.classList.remove('btn--secondary');
         button.classList.add('btn--primary');
        label.textContent = "";
        if (event.target.checked) {
            createHiddenInput(productName);
            label.textContent = "Remove from Box";
        } else {
            removeHiddenInput(productName);
            var button = checkboxMain.parentElement;
            button.classList.remove('btn--primary');
            button.classList.add('btn--secondary');
            label.textContent = "Add to Box";
        }

       
        const checkboxesCount = document.querySelectorAll('#checkboxes input[data-id-products="'+ sectionId +'"]');
        const checkboxes = document.querySelectorAll('#checkboxes input[data-id-products="'+ sectionId +'"]');
        const showCount = document.querySelector('#checkbox_count_'+ sectionId +'_product');
        const addedSec = document.querySelector('#cart_'+ sectionId +'_added');
        const tabComplete = document.querySelector('.parent_'+ sectionId);
        const allCheckboxes = document.querySelectorAll('.select-btn');
        var mainPrice = document.querySelector('.prd-price span.money');
        var mainHdnPrice = document.querySelector('span.psptem');
        var tabhead = document.querySelector('.tab-items');
        let checkedCount = 0;
        let totalPrice = 0;
        let selectedCount = 0;
        

         // Loop through each checkbox
         allCheckboxes.forEach(checkbox => {
            // Check if checkbox is checked
            if (checkbox.checked) {
            const price = parseFloat(checkbox.getAttribute('data-price-variant'));
            totalPrice += price;
            selectedCount++;
            }
        });

        if (totalPrice) {
            document.getElementById('total-price').style.display = "block";
            document.getElementById('total-price').textContent = "$ " + totalPrice.toFixed(2).replace(/\.00$/, '');
            document.getElementById('total-products').textContent = "(" + selectedCount + ")";
            document.querySelector('.products-count').style.display = 'block';
        } else {
            document.querySelector('.products-count').style.display = 'none';
            document.getElementById('total-price').style.display = "none";
        }
        checkboxesCount.forEach(function(checkbox) {
            if (checkbox.checked) {
                checkedCount++;
            }
        });
        if (limitId) {
            if (limitId == checkedCount) {
                checkboxes.forEach(function(checkbox) {
                    showCount.style.display = "none";
                    addedSec.style.display = "block";
                    tabComplete.classList.add('complete');
                    showCount.textContent = checkedCount;
                    data = checkbox.getAttribute('data-step');
                    var activeTab = document.querySelector('.tab-content[data-id="tab' + data + '"]');
                    activeTab.style.marginTop = '3%';
                    var nextTab = activeTab.nextElementSibling;
                    if (nextTab) {
                        activeTab.classList.remove('active-tab-content');
                        nextTab.classList.add('active-tab-content');
                        // Add margin top to the current tab
                        
                        nextTab.scrollIntoView({ behavior: 'smooth' });
                        var scrollPosition = nextTab.getBoundingClientRect().top - (window.innerHeight * 0.2);
                        window.scrollBy({ top: scrollPosition, behavior: 'smooth' });
                    }
                    if (!checkbox.checked) {
                        checkbox.disabled = true;
                        checkbox.classList.add("disabled");
                    }
                });
            } else {
                if (checkedCount != 0) {
                    addedSec.style.display = "none";
                    showCount.style.display = "block";
                    showCount.textContent = checkedCount;
                } else {
                    showCount.style.display = "none";
                    addedSec.style.display = "none";
                    showCount.textContent = checkedCount;
                }
                checkboxes.forEach(function(checkbox) {
                    if (!checkbox.checked) {
                        checkbox.disabled = false;
                        checkbox.classList.remove("disabled");
                    }
                });
            }
        } else {
            if (limitIdFirst) {
                console.log('checkedCount');
                console.log(checkedCount);
                let checkedCounts = 0;
                checkboxesCount.forEach(function(checkbox) {
                    if (checkbox.checked) {
                        checkedCounts++;
                    }
                });
                if (checkedCounts == 0) {
                    // Get the content of the span element
                    const totalProductsText = document.querySelector('#total-products').textContent;

                    // Extract the number from the content
                    checkedCounts = totalProductsText.match(/\d+/)[0];
                    checkedCount = totalProductsText.match(/\d+/)[0];

                    console.log(checkedCounts); // Outputs: 5

                }
                console.log('checkedCounts');
                console.log(checkedCounts);
                if (checkedCounts <= limitIdFirst ) {
                    console.log('first');

                    const buttons = document.querySelectorAll('.select-btn[type="checkbox"]');
                                // Loop through each button and update the 'data-id-products' attribute
                                buttons.forEach(button => {
                                    button.setAttribute('data-id-products', 'tab_1'); // Replace 'new-value' with your desired value
                                    button.setAttribute('data-step', '1'); // Replace 'new-value' with your desired value
                                });
                                const checkboxesParents = document.querySelectorAll('#checkboxes');
        
                                // Loop through each parent element with id "checkboxes" and update its attribute
                                checkboxesParents.forEach(parent => {
                                    parent.setAttribute("data-sec-id", "tab_1"); // Replace "data-parent-attribute" and "parent-value" with your desired attribute and value
                                    parent.setAttribute("data-step", "1"); // Replace "data-parent-attribute" and "parent-value" with your desired attribute and value
                                });
                } else if (checkedCount <= limitIdSecond) {
                    console.log('second');
                    var step1 = document.querySelector('#cart_tab_1_added');
                    var step2 = document.querySelector('#cart_tab_2_added');
                    var step3 = document.querySelector('#cart_tab_3_added');
                        step1.style.display = 'block';
                        step2.style.display = 'block';
                        step3.style.display = 'none';   
                    const buttons = document.querySelectorAll('.select-btn[type="checkbox"]');
                                // Loop through each button and update the 'data-id-products' attribute
                                buttons.forEach(button => {
                                    button.setAttribute('data-id-products', 'tab_2'); // Replace 'new-value' with your desired value
                                    button.setAttribute('data-step', '2'); // Replace 'new-value' with your desired value
                                });
                                const checkboxesParents = document.querySelectorAll('#checkboxes');
        
                                // Loop through each parent element with id "checkboxes" and update its attribute
                                checkboxesParents.forEach(parent => {
                                    parent.setAttribute("data-sec-id", "tab_2"); // Replace "data-parent-attribute" and "parent-value" with your desired attribute and value
                                    parent.setAttribute("data-step", "2"); // Replace "data-parent-attribute" and "parent-value" with your desired attribute and value
                                });
                } else if (checkedCount <= limitIdThird) {
                    console.log('third');
                   
                    const buttons = document.querySelectorAll('.select-btn[type="checkbox"]');
                                // Loop through each button and update the 'data-id-products' attribute
                                buttons.forEach(button => {
                                    button.setAttribute('data-id-products', 'tab_3'); // Replace 'new-value' with your desired value
                                    button.setAttribute('data-step', '3'); // Replace 'new-value' with your desired value
                                });
                                const checkboxesParents = document.querySelectorAll('#checkboxes');
        
                                // Loop through each parent element with id "checkboxes" and update its attribute
                                checkboxesParents.forEach(parent => {
                                    parent.setAttribute("data-sec-id", "tab_3"); // Replace "data-parent-attribute" and "parent-value" with your desired attribute and value
                                    parent.setAttribute("data-step", "3"); // Replace "data-parent-attribute" and "parent-value" with your desired attribute and value
                                });
                }
               
                var subHeading = document.querySelector('a.tab.active-tab .sticky-header-bubble .heading-offer');
                if (!subHeading) {
                var subHeading = document.querySelector('.heading-offer');
                }
                    if (limitIdFirst == checkedCount) {
                        checkboxes.forEach(function(checkbox) {
                            showCount.style.display = "none";
                            addedSec.style.display = "block";
                            var tabCompleted1 = document.querySelector('.tab-item.parent_tab_1');
                            var tabCompleted2 = document.querySelector('.tab-item.parent_tab_2');
                            var tabCompleted3 = document.querySelector('.tab-item.parent_tab_3');
                            tabCompleted1.classList.add('complete');
                            tabCompleted2.classList.remove('complete');
                            tabCompleted3.classList.remove('complete');
                            var step1 = document.querySelector('#cart_tab_1_added');
                                        var step2 = document.querySelector('#cart_tab_2_added');
                                        var step3 = document.querySelector('#cart_tab_3_added');
                                            step1.style.display = 'block';
                                            step2.style.setProperty('display', 'none', 'important');
                            step3.style.setProperty('display', 'none', 'important');
                            // console.log('Updated Step2 display:', step2.style.display);
                                                showCount.textContent = checkedCount;
                            data = checkbox.getAttribute('data-step');
                            mainPrice.textContent = offerPriceFirst;
                            mainHdnPrice.textContent = offerPriceFirst;
                            if (limitIdSecond == 0) {
                                if (!checkbox.checked) {
                                    checkbox.disabled = true;
                                    checkbox.classList.add("disabled");
                                }
                            } else {
                                if (!checkbox.checked) {
                                    checkbox.disabled = false;
                                    checkbox.classList.remove("disabled");
                                }
                            }
                        });
                        if (limitIdSecond) {
                            if (tabhead) {
                                tabhead.scrollIntoView({ behavior: 'smooth' });
                                var scrollPosition = tabhead.getBoundingClientRect().top - (window.innerHeight * 0.2);
                                window.scrollBy({ top: scrollPosition, behavior: 'smooth' });
                            }
                            
                            subHeading.style.display = 'block';
                            var diffrenceLimit = limitIdSecond - limitIdFirst;
                           
                            const buttons = document.querySelectorAll('.select-btn[type="checkbox"]');
                            // Loop through each button and update the 'data-id-products' attribute
                            buttons.forEach(button => {
                                button.setAttribute('data-id-products', 'tab_2'); // Replace 'new-value' with your desired value
                                button.setAttribute('data-step', '2'); // Replace 'new-value' with your desired value
                            });
                            const checkboxesParents = document.querySelectorAll('#checkboxes');
    
                            // Loop through each parent element with id "checkboxes" and update its attribute
                            checkboxesParents.forEach(parent => {
                                parent.setAttribute("data-sec-id", "tab_2"); // Replace "data-parent-attribute" and "parent-value" with your desired attribute and value
                                parent.setAttribute("data-step", "2"); // Replace "data-parent-attribute" and "parent-value" with your desired attribute and value
                            });
                        }
                    } else {
                        if (limitIdSecond) {
                            
                            if (checkedCount != 0) {
                                addedSec.style.display = "none";
                                showCount.style.display = "block";
                                showCount.textContent = checkedCount;
                            } else {
                                showCount.style.display = "none";
                                addedSec.style.display = "none";
                                showCount.textContent = checkedCount;
                            }
                            subHeading.style.display = 'none';
                            if (limitIdSecond == checkedCount) {
                                checkboxes.forEach(function(checkbox) {
                                    showCount.style.display = "none";
                                    addedSec.style.display = "block";
                                    var tabCompleted1 = document.querySelector('.tab-item.parent_tab_1');
                                    var tabCompleted2 = document.querySelector('.tab-item.parent_tab_2');
                                    var tabCompleted3 = document.querySelector('.tab-item.parent_tab_3');
                                    tabCompleted1.classList.add('complete');
                                    tabCompleted2.classList.add('complete');
                                    tabCompleted3.classList.remove('complete');
                                    showCount.textContent = checkedCount;
                                    data = checkbox.getAttribute('data-step');
                                    mainPrice.textContent = offerPriceSecond;
                                    mainHdnPrice.textContent = offerPriceSecond;
                                    if (limitIdThird == 0) {
                                        if (!checkbox.checked) {
                                            checkbox.disabled = true;
                                            checkbox.classList.add("disabled");
                                        }
                                    } else {
                                        if (!checkbox.checked) {
                                            checkbox.disabled = false;
                                            checkbox.classList.remove("disabled");
                                        }
                                    }
                                });
                                if (limitIdThird) {
                                    var step1 = document.querySelector('#cart_tab_1_added');
                    var step2 = document.querySelector('#cart_tab_2_added');
                    var step3 = document.querySelector('#cart_tab_3_added');
                        step1.style.display = 'block';
                        step2.style.display = 'block';
                        step3.style.display = 'none';
                                    var totalCount = parseInt(limitIdFirst) + parseInt(limitIdSecond);
                                    var tab3 = document.querySelector('.parent_tab_3');
                                    const dataLimitId = tab3.getAttribute('data-limit-id');
                                    if (tabhead) {
                                        tabhead.scrollIntoView({ behavior: 'smooth' });
                                        var scrollPosition = tabhead.getBoundingClientRect().top - (window.innerHeight * 0.2);
                                        window.scrollBy({ top: scrollPosition, behavior: 'smooth' });
                                    }
                                    subHeading.style.display = 'block';
                                    var diffrenceLimit = limitIdThird - limitIdSecond;
                                   
                                    const buttons = document.querySelectorAll('.select-btn[type="checkbox"]');
                                // Loop through each button and update the 'data-id-products' attribute
                                buttons.forEach(button => {
                                    button.setAttribute('data-id-products', 'tab_3'); // Replace 'new-value' with your desired value
                                    button.setAttribute('data-step', '3'); // Replace 'new-value' with your desired value
                                });
                                const checkboxesParents = document.querySelectorAll('#checkboxes');
        
                                // Loop through each parent element with id "checkboxes" and update its attribute
                                checkboxesParents.forEach(parent => {
                                    parent.setAttribute("data-sec-id", "tab_3"); // Replace "data-parent-attribute" and "parent-value" with your desired attribute and value
                                    parent.setAttribute("data-step", "3"); // Replace "data-parent-attribute" and "parent-value" with your desired attribute and value
                                });
                                }
                            } else {
                                if (limitIdThird) {
                                    if (checkedCount != 0) {
                                        addedSec.style.display = "none";
                                        showCount.style.display = "block";
                                        showCount.textContent = checkedCount;
                                    } else {
                                        showCount.style.display = "none";
                                        addedSec.style.display = "none";
                                        showCount.textContent = checkedCount;
                                    }
                                    subHeading.style.display = 'none';
                                    if (limitIdThird == checkedCount) {
                                        checkboxes.forEach(function(checkbox) {
                                            showCount.style.display = "none";
                                            addedSec.style.display = "block";
                                            var tabCompleted1 = document.querySelector('.tab-item.parent_tab_1');
                                            var tabCompleted2 = document.querySelector('.tab-item.parent_tab_2');
                                            var tabCompleted3 = document.querySelector('.tab-item.parent_tab_3');
                                            tabCompleted1.classList.add('complete');
                                            tabCompleted2.classList.add('complete');
                                            tabCompleted3.classList.add('complete');
                                            showCount.textContent = checkedCount;
                                            data = checkbox.getAttribute('data-step');
                                            mainPrice.textContent = offerPriceThird;
                                            mainHdnPrice.textContent = offerPriceThird;
                                            if (!checkbox.checked) {
                                                checkbox.disabled = true;
                                                checkbox.classList.add("disabled");
                                            } else {
                                                if (!checkbox.checked) {
                                                    checkbox.disabled = false;
                                                    checkbox.classList.remove("disabled");
                                                }
                                            }
                                        });
                                    } else {
                                        if (checkedCount != 0) {
                                            addedSec.style.display = "none";
                                            showCount.style.display = "block";
                                            showCount.textContent = checkedCount;
                                        } else {
                                            showCount.style.display = "none";
                                            addedSec.style.display = "none";
                                            showCount.textContent = checkedCount;
                                        }
                                        checkboxes.forEach(function(checkbox) {
                                            if (!checkbox.checked) {
                                                checkbox.disabled = false;
                                                checkbox.classList.remove("disabled");
                                            }
                                        });
                                    }
                                    var completeStep1 = document.querySelector('#checkbox_count_tab_1_product');
                                    var completeStep2 = document.querySelector('#checkbox_count_tab_2_product');
                                    var completeStep3 = document.querySelector('#checkbox_count_tab_3_product');
                                    var step1 = document.querySelector('#cart_tab_1_added');
                                    var step1 = document.querySelector('#cart_tab_1_added');
                                    var step2 = document.querySelector('#cart_tab_2_added');
                                    var step3 = document.querySelector('#cart_tab_3_added');
                                         
                                    if (checkedCount <= limitIdFirst) {
                                        console.log('1 complete');
                                        completeStep1.style.display = 'block';
                                        completeStep2.style.display = 'none';
                                        completeStep3.style.display = 'none';
                                    } else if (checkedCount > limitIdFirst && checkedCount <= limitIdSecond) {
                                        console.log('2 complete');
                                        completeStep1.style.display = 'block';
                                        completeStep2.style.display = 'block';
                                        completeStep3.style.display = 'none';
                                        step2.style.display = 'none';
                                    } else if (checkedCount == limitIdSecond) {
                                        console.log('3 complete');
                                        completeStep1.style.display = 'block';
                                        completeStep2.style.display = 'block';
                                        completeStep3.style.display = 'block';
                                    }
                                }
                            }
                        }
                    }
            } 
        
        }
}
function createHiddenInput(productName) {
    const hiddenInputsContainer = document.getElementById('hiddenInputsContainer');
    // Check if an input with the same value already exists
    const existingInput = hiddenInputsContainer.querySelector(`input[value="${productName}"]`);
    if (existingInput) {
        return; // Exit the function if the input already exists
    }
    hiddenInputsContainer.querySelectorAll('input').forEach((input, index) => {
        input.name = `properties[ITEM ${index + 1}]`;
    });
    hiddenInputsContainer.querySelectorAll('input').forEach((input, index) => {
        input.name = `properties[ITEM ${index + 1}]`;
    });
    let inputCount = 1;

    // Find the highest count
    hiddenInputsContainer.querySelectorAll('input').forEach(input => {
        const regex = /properties\[ITEM\s+(\d+)\]/;
        const match = regex.exec(input.name);
        if (match) {
            inputCount = Math.max(inputCount, parseInt(match[1]) + 1);
        }
    });
   

    // Create a new input with the incremented count
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = `properties[ITEM ${inputCount}]`;
    input.value = productName;
    hiddenInputsContainer.appendChild(input);
}

function removeHiddenInput(productName) {
    
    const hiddenInputsContainer = document.getElementById('hiddenInputsContainer');
    hiddenInputsContainer.querySelectorAll('input').forEach((input, index) => {
        input.name = `properties[ITEM ${index + 1}]`;
    });
    const inputToRemove = hiddenInputsContainer.querySelector(`input[value="${productName}"]`);
    if (inputToRemove) {
        hiddenInputsContainer.removeChild(inputToRemove);
    }
}

function scrollSection() {
    
    var tabLinks = document.querySelectorAll('.tab');
    
   
    tabLinks.forEach(function(tabLink) {
        tabLink.addEventListener('click', function(event) {
            // Remove 'active-tab' class from all tab links
            tabLinks.forEach(function(link) {
                link.classList.remove('active-tab');
            });
            
            event.preventDefault(); 
            var tabId = tabLink.getAttribute('data-id'); 
            var tabContent = document.querySelector('.tab-content[data-id="' + tabId + '"]'); 

            // Scroll to the tab content
            tabContent.scrollIntoView({ behavior: 'smooth' });
            var scrollPosition = tabContent.getBoundingClientRect().top - (window.innerHeight * 0.2);
            window.scrollBy({ top: scrollPosition, behavior: 'smooth' });
        });
    });

    // Function to activate tab based on scroll position
    function activateTab() {
        const tabs = document.querySelectorAll('.tab');
        document.querySelectorAll('.tab-content').forEach(content => {
            const rect = content.getBoundingClientRect();
            if (rect.top <= window.innerHeight / 2 && rect.bottom >= window.innerHeight / 2) {
                const contentTabId = content.getAttribute('data-id');
                tabs.forEach(tab => {
                    if (tab.getAttribute('data-id') === contentTabId) {
                        tab.classList.add('active-tab');
                    } else {
                        tab.classList.remove('active-tab');
                    }
                });
            }
        });
    }
    
    // Activate tab on page load
    activateTab();
}

function imageAnimation() {
    var parentDivs = document.querySelectorAll('.product-item__inner');
    parentDivs.forEach(function(parentDiv) {
        var image = parentDiv.querySelector('.product-item__image--two');

        parentDiv.addEventListener('mouseover', function() {
            image.classList.add('active');
        });

        parentDiv.addEventListener('mouseout', function() {
            image.classList.remove('active');
        });
    });
}

function handleScroll() {
    // Get all tab links
    const tabs = document.querySelectorAll('.tab');

    // Loop through each tab content
    document.querySelectorAll('.tab-content').forEach(content => {
        // Check if the content is in the viewport
        const rect = content.getBoundingClientRect();
        if (rect.top <= window.innerHeight && rect.bottom >= 0) {

            // Find the corresponding tab link and add the active class
            const tabId = content.getAttribute('data-id');
            tabs.forEach(tab => {
                if (tab.getAttribute('data-id') === tabId) {
                    tab.classList.add('active-tab');
                } else {
                    tab.classList.remove('active-tab');
                }
            });
        }
    });
}
document.addEventListener('DOMContentLoaded', function() {
    const addToCartButton = document.querySelector('.offer-add-to-cart .product-form__cart-submit');
    const addToCartButtonText = document.querySelector('.offer-add-to-cart .product-form__cart-submit span');
    const replaceButton = document.getElementById('replaceButton');
    const closePopup = document.querySelector('.close-popup');
    const varientClosePopup = document.querySelector('.varient-close-popup');
    const openCart = document.querySelector(".btn.btn--primary.btn--small.btn--full.open-cart");
    
    let popupWrn;

    if (openCart) {
        openCart.addEventListener("click", async function() {
            const cartPageResponse = await fetch('/cart');
            const cartPageText = await cartPageResponse.text();
            const parser = new DOMParser();
            const cartPageDoc = parser.parseFromString(cartPageText, 'text/html');
            const cartIcon = document.querySelector('[data-js-cart-icon]');
            const cartDrawer = document.querySelector('.quick-cart__wrapper');
            const newCartContent = cartPageDoc.querySelector('.quick-cart__wrapper'); 
            if (cartDrawer && newCartContent) {
                cartDrawer.innerHTML = newCartContent.innerHTML;
                cartDrawer.classList.add('active');
            }
            if (cartIcon) {
                cartIcon.click(); 
            } else {
                console.warn('Cart icon with [data-js-cart-icon] not found.');
            }
            // window.location.href = "/cart"; // Update with the correct cart URL if different
        });
    }

    if (closePopup) {
        closePopup.addEventListener('click', function(event) {
            event.preventDefault();
            popupWrn = document.querySelector('.popup-container.popup-style-2');
            popupWrn.classList.remove('active');
            addToCartButtonText.innerHTML = "Create";
            addToCartButton.classList.remove('spinning');
            addToCartButton.disabled = false;
        });
    }

    if (varientClosePopup) {
        varientClosePopup.addEventListener('click', function(event) {
            event.preventDefault();
            popupWrns = varientClosePopup.parent;
            popupWrns.classList.remove('show');
            popupWrns.classList.add('hidden');
            addToCartButtonText.innerHTML = "Create Box";
            addToCartButton.classList.remove('spinning');
            addToCartButton.disabled = false;
        });
    }

    if (addToCartButton) {
        addToCartButton.addEventListener('click', async function(event) {
            event.preventDefault();
            addToCartButtonText.innerHTML = "Creating";
            addToCartButton.disabled = true;
            addToCartButton.classList.add('spinning');
            let response = await fetch('/cart.js');
            let cart = await response.json();
            for (let item of cart.items) {
                if (item.properties && item.properties.Offer) {
                    const popupWrn = document.querySelector('.popup-container.popup-style-2');
                    if (popupWrn) {
                        popupWrn.classList.add('active');
                    }
                    return;
                }
            }

            const radioButtons = document.querySelectorAll('.button.select-btn');
            const selectedRadioData = [];
            radioButtons.forEach(function(radioButton) {
                if (radioButton.checked) {
                    const radioData = radioButton.getAttribute('data-id-variant');
                    selectedRadioData.push(radioData);
                }
            });

            if (selectedRadioData.length === 0) {
                console.warn('No product selected.');
                return;
            }

            let selectedRadioDatas = [];
            let total = 0;

            radioButtons.forEach(function(radioButton) {
                if (radioButton.checked) {
                    let radioData = radioButton.getAttribute('data-id-variant');
                    let priceCurrent = radioButton.getAttribute('data-price-variant');
                    let priceNumeric = parseFloat(priceCurrent);
                    total += priceNumeric;
                    selectedRadioDatas.push(radioData);
                }
            });

            let productIds = selectedRadioDatas;
            let mainOfferPrices = parseFloat(document.querySelector('.psptem').textContent.replace(/[^0-9.-]+/g, ""));
            let totalPrice = total;
            let offerPrice = mainOfferPrices;
            const currentDate = new Date();
            const formattedDate = currentDate.getFullYear().toString() +
                                    (currentDate.getMonth() + 1).toString().padStart(2, '0') +
                                    currentDate.getDate().toString().padStart(2, '0');
            
            const hashFormate = String(offerPrice.toString() + formattedDate);


            

            var hashResult =  CryptoJS.MD5(hashFormate).toString(CryptoJS.enc.Hex);
           

            const mainOfferTitle = document.querySelector('.prd-image-title h3').textContent;
            const mainOfferImage = document.querySelector('.prd-image-title img');
            const mainSrc = mainOfferImage ? mainOfferImage.getAttribute('src') : null;
            const mainOfferPrice = document.querySelector('.psptem').textContent;
            const currentUrl = window.location.href;

            for (let index = 0; index < selectedRadioData.length; index++) {
                await addProductWithRetry(selectedRadioData[index], {
                    'Offer': mainOfferTitle,
                    'Price': mainOfferPrice,
                    'Image': mainSrc,
                    'PageUrl': currentUrl
                }, 3);
            }
            try {
                let response = await fetch('https://cpanel.mensabrands.com/BYOB_latest/public/discountGenerate', {
                    method: "POST",
                    headers: {
                        "Accept": "application/json",
                        "Content-type": "application/json",
                        "Authorization": `Bearer ${window.sessionToken}`
                    }, 
                    body: JSON.stringify({
                        variant_IDs: productIds,
                        total_price: totalPrice,
                        offer_price: offerPrice,
                        htop: hashResult,
                        store_name:'MajesticPure'
                    })
                });
                let res = await response.json();
                console.log("res",res);                
                let discount_code = res['Discount code'];

                let discountApplyResponse = await fetch(`/discount/${discount_code}`, {
                    method: 'GET',
                });

                // Check if the response is HTML (assuming the status code is still 200)
                // let contentType = discountApplyResponse.headers.get('content-type');
                // console.log("contentType",contentType);
                
                // if (contentType && contentType.includes('text/html')) {
                //     console.error('Expected JSON but received HTML. Skipping JSON parsing.');
                // } else {
                //     let data = await discountApplyResponse.json();

                //     if (data.success) {
                //     } else {
                //         console.log('Discount failed:', data.message);
                //     }
                // }
            } catch (error) {
                console.error('Error:', error);
            }
            // await updateCart();
            const cartPageResponse = await fetch('/cart');
            const cartPageText = await cartPageResponse.text();
            const parser = new DOMParser();
            const cartPageDoc = parser.parseFromString(cartPageText, 'text/html');
            const cartIcon = document.querySelector('[data-js-cart-icon]');
            const cartDrawer = document.querySelector('.quick-cart__wrapper');
            const newCartContent = cartPageDoc.querySelector('.quick-cart__wrapper'); 
            var cartCount = await fetch('/cart.js');
            var countData = await cartCount.json();
            document.querySelectorAll('[data-js-cart-count]').forEach(counter => {
                counter.textContent = countData.item_count;
            });
            if (cartDrawer && newCartContent) {
                cartDrawer.innerHTML = newCartContent.innerHTML;
                cartDrawer.classList.add('active');
            }
            if (cartIcon) {
                cartIcon.click(); 
            } else {
                console.warn('Cart icon with [data-js-cart-icon] not found.');
            }
            // window.location.href=`/cart/discount/${discount_code}`;
          
            addToCartButtonText.innerHTML = "Created";
            addToCartButton.classList.remove('spinning');
            addToCartButton.disabled = false;
            qtyBtnClick();
        });
    }
    if (replaceButton) {
        replaceButton.addEventListener('click', async function(event) {
            event.preventDefault();
            
            try {
                replaceButton.disabled = true;
                replaceButton.classList.add('spinning');
                // Fetch the current cart content
                const cartResponse = await fetch('/cart', {
                    method: 'GET'
                });
    
                if (!cartResponse.ok) {
                    throw new Error('Network response was not ok');
                }
    
                let cartData = await cartResponse.text();
                const parser = new DOMParser();
                const cartHtml = parser.parseFromString(cartData, "text/html");
                var container = cartHtml.querySelector('.quick-cart__items');
                if (!container) {
                    throw new Error('Container with class .quick-cart__items not found');
                }
    
                // Find checkboxes for product removal
                var inputFields = container.querySelectorAll('.cart-variant-ids');
                // console.log("inputFields",inputFields);
                if (inputFields.length === 0) {
                    throw new Error('No checkboxes with class .button.select-btn found');
                }
    
                var formData = new FormData();
    
                // Prepare FormData to remove all items from the cart
                inputFields.forEach(function(inputField) {
                    var productId = inputField.getAttribute('data-id');
                    // console.log(productId,"productId");
                    var newQuantity = 0; 
    
                    formData.append('updates[' + productId + ']', newQuantity);
                });
    
                // Update the cart to remove items
                let updateCartResponse = await fetch('/cart/update.js', {
                    method: 'POST',
                    body: formData
                });
     
                if (!updateCartResponse.ok) {
                    throw new Error('Network response was not ok');
                }
    
                let radioButtons = document.querySelectorAll('.button.select-btn');
                let selectedRadioDataas = [];
                let total = 0;
    
                radioButtons.forEach(function(radioButton) {
                    if (radioButton.checked) {
                        let radioData = radioButton.getAttribute('data-id-variant');
                        let priceCurrent = radioButton.getAttribute('data-price-variant');
                        let priceNumeric = parseFloat(priceCurrent);
                        total += priceNumeric;
                        selectedRadioDataas.push(radioData);
                    }
                });
    
                if (selectedRadioDataas.length === 0) {
                    console.warn('No product selected.');
                    return;
                }
    
                
    
                let productIds = selectedRadioDataas;
                let mainOfferPrices = parseFloat(document.querySelector('.psptem').textContent.replace(/[^0-9.-]+/g, ""));
                let totalPrice = total;
                let offerPrice = mainOfferPrices;
                const currentDate = new Date();
                const formattedDate = currentDate.getFullYear().toString() +
                                        (currentDate.getMonth() + 1).toString().padStart(2, '0') +
                                        currentDate.getDate().toString().padStart(2, '0');
                
                const hashFormate = String(offerPrice.toString() + formattedDate);


                

                var hashResult =  CryptoJS.MD5(hashFormate).toString(CryptoJS.enc.Hex);
                // Request to generate a discount code
                let discountResponse = await fetch('https://cpanel.mensabrands.com/BYOB_latest/public/discountGenerate', {
                    method: "POST",
                    headers: {
                        "Accept": "application/json",
                        "Content-type": "application/json",
                        "Authorization": `Bearer ${window.sessionToken}`
                    },
                    body: JSON.stringify({
                        variant_IDs: productIds,
                        total_price: totalPrice,
                        offer_price: offerPrice,
                        htop: hashResult,
                        store_name:'MajesticPure'
                    })
                });
                
                let discountData = await discountResponse.json();
                console.log("res-1",discountData);
                let discountCode = discountData['Discount code'];
    
                // Apply the discount code
                let discountApplyResponse = await fetch(`/discount/${discountCode}`, {
                    method: 'GET',
                });
    
                let contentType = discountApplyResponse.headers.get('content-type');
                // console.log("contentType-1",contentType);
                // if (contentType && contentType.includes('application/json')) {
                //     let data = await discountApplyResponse.json();
    
                //     if (!data.success) {
                //         console.log('Discount failed:', data.message);
                //     }
                // } else {
                //     console.error('Expected JSON but received HTML. Skipping JSON parsing.');
                // }
    
                // Add the new product to the cart
                const mainOfferTitle = document.querySelector('.prd-image-title h3').textContent;
                const mainOfferImage = document.querySelector('.prd-image-title img');
                const mainOfferPrice = document.querySelector('.psptem').textContent;
                const mainSrc = mainOfferImage ? mainOfferImage.getAttribute('src') : null;
                const currentUrl = window.location.href;
    
                for (let index = 0; index < selectedRadioDataas.length; index++) {
                    await addProductWithRetry(selectedRadioDataas[index], {
                        'Offer': mainOfferTitle,
                        'Price': mainOfferPrice,
                        'Image': mainSrc,
                        'PageUrl': currentUrl
                    }, 3);
                }
                // window.location.href='/cart';
                addToCartButtonText.innerHTML = "Created";
                addToCartButton.classList.remove('spinning');
                addToCartButton.disabled = false;
                // Apply the discount code
                // let discountApplyResponses = await fetch(`/discount/${discountCode}`, {
                //     method: 'GET',
                // });
    
                // let contentTypes = discountApplyResponses.headers.get('content-type');
                // if (contentTypes && contentTypes.includes('application/json')) {
                //     let data = await discountApplyResponses.json();
    
                //     if (!data.success) {
                //         console.log('Discount failed:', data.message);
                //     }
                // } else {
                //     console.error('Expected JSON but received HTML. Skipping JSON parsing.');
                // }
                const cartPageResponse = await fetch('/cart');
                const cartPageText = await cartPageResponse.text();
                const cartPageDoc = parser.parseFromString(cartPageText, 'text/html');
                const cartIcon = document.querySelector('[data-js-cart-icon]');
                const cartDrawer = document.querySelector('.quick-cart__wrapper');
                const newCartContent = cartPageDoc.querySelector('.quick-cart__wrapper'); 
                var cartCount = await fetch('/cart.js');
                var countData = await cartCount.json();
                document.querySelectorAll('[data-js-cart-count]').forEach(counter => {
                    counter.textContent = countData.item_count;
                });
                if (cartDrawer && newCartContent) {
                    cartDrawer.innerHTML = newCartContent.innerHTML;
                    cartDrawer.classList.add('active');
                }
                if (cartIcon) {
                    cartIcon.click(); 
                } else {
                    console.warn('Cart icon with [data-js-cart-icon] not found.');
                }
                popupWrn = document.querySelector('.popup-container.popup-style-2');
                popupWrn.classList.remove('active');
            } catch (error) {
                console.error('Error:', error);
                addToCartButtonText.innerHTML = "Error";
                addToCartButton.classList.remove('spinning');
                addToCartButton.disabled = false;
            }
        });
    }
    qtyBtnClick();
    
});

const qtyBtnClick = () => {
    document.removeEventListener('click', handleQtyClick); 
    document.addEventListener('click', handleQtyClick);
};
  
const handleQtyClick = async (event) => {
const addBtn = event.target.closest('.custom-byob-add-item');
const subBtn = event.target.closest('.custom-byob-subtract-item');

if (!addBtn && !subBtn) return;

const isAdd = !!addBtn;

try {
    const cart = await fetch('/cart.js').then(res => res.json());

    const offerItems = cart.items.filter(item =>
    item.properties && item.properties['Offer'] !== undefined
    );

    if (offerItems.length === 0) {
    console.log('No offer items found in cart');
    return;
    }

    const updates = {};
    offerItems.forEach(item => {
    const newQty = isAdd
        ? item.quantity + 1
        : Math.max(item.quantity - 1, 0);
    updates[item.key] = newQty;
    });

    const updateResponse = await fetch('/cart/update.js', {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
    body: JSON.stringify({ updates }),
    });

    if (!updateResponse.ok) {
    const errorText = await updateResponse.text();
    console.error('Cart update failed with response:', errorText);
    throw new Error('Cart update failed: ' + errorText);
    }

    const result = await updateResponse.json();
    console.log('Cart updated successfully:', result);

    generateDiscount(result.items);

    setTimeout(() => {
    newCartUpdate();
    }, 3000);

} catch (error) {
    console.error('Error updating cart:', error);
}
};

const generateDiscount = async (cartItems) => {
try {
    const offerItems = cartItems.filter(item =>
    item.properties && item.properties['Offer'] !== undefined
    );

    if (offerItems.length === 0) {
    console.log('No offer items found to generate discount');
    return;
    }

    const productIds = offerItems.map(item => item.variant_id.toString());

    let totalPrice = 0;
    let offerPrice = cartItems[0]?.properties?.['Price'] || 0;
    offerPrice = offerPrice * cartItems[0].quantity;

    offerItems.forEach(item => {
    totalPrice += (item.price * item.quantity) / 100;
    });

    const currentDate = new Date();
    const formattedDate =
    currentDate.getFullYear().toString() +
    (currentDate.getMonth() + 1).toString().padStart(2, '0') +
    currentDate.getDate().toString().padStart(2, '0');

    const hashFormate = offerPrice.toString() + formattedDate;
    const hashResult = CryptoJS.MD5(hashFormate).toString(CryptoJS.enc.Hex);

    const response = await fetch('https://cpanel.mensabrands.com/BYOB_latest/public/discountGenerate', {
    method: 'POST',
    headers: {
        'Accept': 'application/json',
        'Content-type': 'application/json',
        'Authorization': `Bearer ${window.sessionToken}`,
    },
    body: JSON.stringify({
        variant_IDs: productIds,
        total_price: totalPrice,
        offer_price: offerPrice,
        htop: hashResult,
        store_name: 'MajesticPure',
    }),
    });

    const res = await response.json();
    const discount_code = res['Discount code'];
    console.log('New discount code generated:', discount_code);

    await jQuery.ajax({
    url: `/discount/${discount_code}`,
    method: 'GET',
    success: function () {
        console.log('New discount applied successfully');
    },
    error: function (err) {
        console.error('Discount apply error:', err);
    },
    });

} catch (error) {
    console.error('Error generating discount:', error);
}
};

const newCartUpdate = async () => {
    try {
        const cartPageResponse = await fetch('/cart');
        const cartPageText = await cartPageResponse.text();
        const parser = new DOMParser();
        const cartPageDoc = parser.parseFromString(cartPageText, 'text/html');

        const cartIcon = document.querySelector('[data-js-cart-icon]');
        const cartDrawer = document.querySelector('.quick-cart__wrapper');
        const newCartContent = cartPageDoc.querySelector('.quick-cart__wrapper'); 

        if (cartDrawer && newCartContent) {
            cartDrawer.innerHTML = newCartContent.innerHTML;
            cartDrawer.classList.add('active');
        }

        if (cartIcon) {
            cartIcon.click(); 
        } else {
            console.warn('Cart icon with [data-js-cart-icon] not found.');
        }
    } catch (error) {
        console.error('Error updating cart UI:', error);
    }
};


async function updateCart() {
    try {
        const cartResponse = await fetch('/cart', {
            method: 'GET'
          });

        if (!cartResponse.ok) {
            throw new Error('Network response was not ok');
        }

        let cartData = await cartResponse.text();

        const parser = new DOMParser();
        const cartHtml = parser.parseFromString(cartData, "text/html");

        const quickCartContainer = document.querySelector('.desktop_cart_item');
        const cartContainerHtml = cartHtml.querySelector('.desktop_cart_item');
        const quickCartContainerProgress = document.querySelector('.cart-progressbar-index');
        const cartContainerHtmlProgress = cartHtml.querySelector('.cart-progressbar-index');    

        if (quickCartContainer && cartContainerHtml) {
            quickCartContainer.innerHTML = cartContainerHtml.innerHTML;
            if (quickCartContainerProgress && cartContainerHtmlProgress) {
                quickCartContainerProgress.innerHTML = cartContainerHtmlProgress.innerHTML;
            }
            loadScript();            
        } else {
            console.error('No .quick-cart__container element found in the response HTML or on the page.');
        }
    } catch (error) {
        console.error('Error updating the cart:', error);
    }
}

async function addProductWithRetry(productId, properties, retries) {
    for (let attempt = 1; attempt <= retries; attempt++) {
        try {
            await new Promise(resolve => setTimeout(resolve, 300));
            await addProductToCartMin(productId, properties);
            break;
        } catch (error) {
            console.error(`Failed to add product ID ${productId} to cart (attempt ${attempt}):`, error);
            if (attempt === retries) {
                console.error(`Giving up after ${retries} attempts`);
            }
        }
    }
}

async function addProductToCartMin(productId, properties) {
    const data = {
        quantity: 1,
        id: productId,
        properties: properties
    };

    try {
        let response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        // console.log(response,"response");
        
        if (!response.ok) {
            throw new Error(`Network response was not ok: ${response.statusText}`);
        }
        // const cartPageResponse = await fetch('/cart');
        // const cartPageText = await cartPageResponse.text();
        // const parser = new DOMParser();
        // const cartPageDoc = parser.parseFromString(cartPageText, 'text/html');
 
        // const cartDrawer = document.querySelector('.quick-cart__wrapper');
        // const newCartContent = cartPageDoc.querySelector('.quick-cart__wrapper'); 
 
        // if (cartDrawer && newCartContent) {
        //     cartDrawer.innerHTML = newCartContent.innerHTML;
        //     cartDrawer.classList.add('active');
        // }
        // const cartIcon = document.querySelector('[data-js-cart-icon]');
        // if (cartIcon) {
        //     cartIcon.click(); 
        // } else {
        //     console.warn('Cart icon with [data-js-cart-icon] not found.');
        // }
    } catch (error) {
        console.error('Error adding product to cart:', error);
        throw error;
    }
}
